module.exports = __webpack_public_path__ + "media/images/covers/Live-Results-Mobile-780cdd35c58a9bf176d44ea71f72d84e.png";